import React, {useEffect} from 'react'
import logogridStyle from "../components/css/logogridStyle.module.scss"


export default function({logos}){
   
    return (
        <section className={logogridStyle.content}>
        {
            logos.map(logo=>{
                logo.image = "adobe.png"; // just for now
                return(
                    <div><img src={"/assets/"+logo.image}/></div>
                )
            })
        }           
        </section>
    )
}